import type {Reducer} from 'react';

export type RequiredItem = {
  key: string;
  complete: boolean;
};

export type SectionRules<S> = {
  visible: (state: S) => boolean;
  required: (state: S) => RequiredItem[];
};

export type NoteDefinition<S, A> = {
  createInitialState: () => S;
  reducer: Reducer<S, A>;
  sections: Record<string, SectionRules<S>>;
  composeNarrative: (state: S) => string;
};

export type SectionProgress = {
  visible: boolean;
  complete: boolean;
};

export type NoteProgress = {
  sections: Record<string, SectionProgress>;
  complete: boolean;
};

export type MemberRef = {id: string; name: string};

export type Choice<K extends string = string> = {key: K; label: string};

export const toSelectItems = <K extends string>(
  choices: readonly Choice<K>[],
) => choices.map(({key, label}) => ({label, value: key}));

export const OTHER = 'other';

export type Checklist = {
  selected: string[];
  other: string;
};

export type EncounterState = {
  member: MemberRef | null;
  dateOfService: string;
};

export type ContactMethodState = {
  contactMethod: string | null;
  contactMethodDetail: string;
};

export type NarrativeState = {
  // null follows composeNarrative; a string is the user's edit
  narrative: string | null;
};

export type NarrativeAction =
  {type: 'editNarrative'; value: string} | {type: 'resetNarrative'};
